import React from 'react';
import { NotificationBox } from '../../components/Notifications';
import { Paragraph, Title } from '../../components/Text';
import { ActionText } from '../../components/Flex';

const colors = {
    error: "#F25D5D",
    warning: "#E8AF1D",
    info: "#4277CC",
    success: "var(--sp-success-color)"
};

const Notification = ({ notificationId, type, code, message, hideMsg, log, showLog }) => {
    const color = colors[type];

    return(
        <NotificationBox color={color} onClose={() => hideMsg(notificationId, log)} gap={{ bottom: 4 }}>
            <Title h5 color={color} capitalize>
                {type} {code}
            </Title>
            <Paragraph>
                {message}
            </Paragraph>
            {log &&
            <ActionText onClick={() => showLog(notificationId)}>Show log</ActionText>}
        </NotificationBox>
    )
};

export { Notification };